import { MouseEvent, FocusEvent } from 'react';

import { ScreenReaderOnly } from 'approot/shared/styles/global.styles';
import inquisitiveLogoPath from 'approot/shared/layout/logo/inquisitive_logo.svg';
import { HeaderLogoStyled, HeaderLogoLinkStyled } from './header.style';

type Props = {
  defaultLogoLink: string;
  logoLink?: string;
  onLogoClick?: (e: MouseEvent<HTMLAnchorElement>) => void;
  onFocus?: (e: FocusEvent<HTMLAnchorElement>) => void;
};

const HeaderLogo = ({
  defaultLogoLink,
  logoLink,
  onLogoClick,
  onFocus,
}: Props) => {
  const img = (
    <>
      <img
        src={inquisitiveLogoPath}
        alt="Inquisitive"
        aria-hidden
        data-selector="inquisitive-header-logo"
      />
      <ScreenReaderOnly>Inquisitive</ScreenReaderOnly>
    </>
  );
  return logoLink === '' ? (
    <HeaderLogoStyled>{img}</HeaderLogoStyled>
  ) : (
    <HeaderLogoStyled>
      <HeaderLogoLinkStyled
        to={logoLink ? logoLink : defaultLogoLink}
        onClick={e =>
          onLogoClick ? onLogoClick(e as MouseEvent<HTMLAnchorElement>) : false
        }
        onFocus={e => (onFocus ? onFocus(e) : false)}
      >
        {img}
      </HeaderLogoLinkStyled>
    </HeaderLogoStyled>
  );
};

export default HeaderLogo;
